import { CanActivateFn } from "@angular/router";
import { inject } from "@angular/core";
import { LoanDashboardService } from "src/app/loan-layout/components/loan-dashboard/loan-dashboard.service";
import { map, take, tap } from "rxjs";

export const dashboardDetailsGuard: CanActivateFn = () => {
    const loanDashboardService = inject(LoanDashboardService);

    return loanDashboardService.timeline$.pipe(
        take(1), // ✅ complete automatically
        tap((res) => {
            if (!res || res.length === 0) {
                loanDashboardService.getDashboardDetails();
            }
        }),
        map((res) => {
            // ❗ BLOCK navigation when data is empty
            if (!res || res.length === 0) {
                return false;
            }
            return true;
        }) // ✅ allow navigation
    );
};
